import { render, staticRenderFns } from "./GatheringStep2.vue?vue&type=template&id=652e3b25&scoped=true&"
import script from "./GatheringStep2.vue?vue&type=script&lang=js&"
export * from "./GatheringStep2.vue?vue&type=script&lang=js&"
import style0 from "./GatheringStep2.vue?vue&type=style&index=0&id=652e3b25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e3b25",
  null
  
)

export default component.exports